import { inject, observer } from 'mobx-react';
import React, { Component } from 'react'

@inject('workAreaStore', 'store', 'photoStore', 'errorStore') @observer
class HiddenUpload extends Component {

  async uploadFiles(types, items){
    if(!items){
      return null
    }
    await Promise.all(Object.keys(items).map(async key => {
      const file = items[key]
      const { name } = file
      const v = name.split('.')
      const t = v[v.length - 1]
      if(!t){
        return
      }
      const type = t.toLowerCase()
      if(!types.includes(type)){
        this.props.errorStore.setErrorMessage('Invalid file type ' + type, true)
        return
      }
      const data = await this.props.photoStore.uploadImage(file, this.props.workAreaStore.designId, this.props.workAreaStore.activeBrand)
      if(data.url){
        const { url, assetId } = data
        if(data.parsedSVG){
          const { parsedSVG, assetColors, rawSVG } = data
          this.props.workAreaStore.insertSVGElement(
            { parsedSVG, assetColors, rawSVG }, 
            this.props.workAreaStore.pages[0].width, 
            this.props.workAreaStore.pages[0].height,
            true
          )
        }else{
          this.props.workAreaStore.insertPhotoFromPaste(url, assetId)
        }
      }else{
        this.props.errorStore.setErrorMessage('Failed to upload ' + name + ' try uploading the image again')
      }
    }))
    const len = items.length
    this.props.errorStore.setErrorMessage('Uploaded ' + len + ' files', false)
    return items.length
  }

  async handleDrop(e){
    e.preventDefault()
    if(this.props.workAreaStore.resizingPage){
      return
    }
    const { store } = this.props
    document.querySelector('.hidden-upload').style.display = 'none'
    if(store.auth){
      if(e.dataTransfer.types.includes('text/html')){
        return
      }
      try{
        if(e.dataTransfer.files && e.dataTransfer.files.length > 0){
          const types = ['svg', 'png', 'jpeg', 'jpg']
          await this.uploadFiles(types, e.dataTransfer.files)
        }
      }catch(err){
        console.log(err)
      }finally{
        document.querySelector('.hidden-upload').style.display = 'none'
      }
    }else{
      return
    }
  }

  hide(){
    document.querySelector('.hidden-upload').style.display = 'none'
  }

  render(){
    return (
      <div 
        className='hidden-upload'
        onClick={() => this.hide()}
        onDrop={this.handleDrop.bind(this)}
      >
        <input
          type='file'
          className='hidden-upload'
          onChange={e => this.handleDrop(e)}
        />
      </div>
    )
  }

}

export default HiddenUpload